<template>
  <GenericReport
    ref="report"
    class="maxh-2bar"
    hide-header
    :reportSpec="reportSpec"
    :adapterSpec="adapterSpec"
    :extraParams="{ vehicleIds: value.id }"
    :selectable="true"
    @update:selected="(v) => (selected = v)"
  >
    <template v-slot:sidebar-extra>
      <v-btn :disabled="selected.length < 1" @click="deleteOccurs">
        Remover...
      </v-btn>
    </template>
  </GenericReport>
</template>

<script>
import GenericReport from 'oderon-vue/cpts/generic-report/GenericReport.vue'
import { fullSpec } from './occur-columns'
import TheUser from 'oderon-vue/auth/TheUser'
import { OrgApi } from '@/models'

export default {
  tabTitle: 'Ocorrências',
  tabGroup: 'Veículo',
  components: {
    GenericReport
  },
  props: {
    value: { required: true }
  },
  data() {
    return {
      adapterSpec: fullSpec,
      selected: []
    }
  },
  computed: {
    reportSpec() {
      let orgId = this.value.orgId
      let apiBase = `/organizations/${orgId}/api/v1/occurrences`
      return {
        code: 'occurs',
        title: 'Ocorrências',
        apiBase,
        filters: [
          'DateRange',
          {
            type: 'OccurConfig',
            label: 'Tipos de Ocorrência',
            prefix: 'config',
            orgId
          }
        ]
      }
    }
  },
  methods: {
    async deleteOccurs() {
      let res = await this.$confirm({
        message: 'Deseja realmente remover estas ocorrências?',
        okText: 'Sim, remover',
        cancelText: 'Não, manter'
      })

      let comments = ''

      if (res) {
        this.$loading(async () => {
          let params = {
            occurIds: this.selectedRowIds,
            comments,
            login: TheUser.user.login
          }

          let fetcher = new OrgApi(this.value.orgId)
          await fetcher.post('occurrences/clean', params)
          this.$refs.report.reload()
          this.$snack('Cancelados com sucesso')
        })
      }
    }
  }
}
</script>

<style></style>
